import { DataCollection } from "@dhx/ts-data";
export interface IComboboxConfig {
	data?: DataCollection<any> | any[];
	readonly?: boolean;
	disabled?: boolean;
	template?: (item: any) => string;
	filter?: (item: any, input: string) => boolean;
	multiselection?: boolean;
	label?: string;
	labelInline?: boolean;
	labelWidth?: string;
	placeholder?: string;
	selectAllButton?: boolean;
	showItemsCount?: boolean | ((count: number) => string);
	cellHeight?: number;
	virtual?: boolean;
	listHeight?: number;
	required?: boolean;
	help?: string;
	hiddenLabel?: boolean;
	css?: string;
}

export interface IComboFilterConfig {
	data?: DataCollection<any> | any[];
	readonly?: boolean;
	template?: (item: any) => string;
	filter?: (item: any, input: string) => boolean;
	placeholder?: string;
	virtual?: boolean;
}

export enum ComboboxEvents {
	change = "change",
	open = "open",
	close = "close",
	input = "input"
}

export interface IComboboxEventHandlersMap {
	[key: string]: (...args: any[]) => any;
	[ComboboxEvents.change]: (ids: string | string[]) => any;
	[ComboboxEvents.close]: () => any;
	[ComboboxEvents.open]: () => any;
	[ComboboxEvents.input]: (value: any) => any;
}

export type State = "success" | "error" | "default";
export interface ICombobox {
	disable(): void; // maybe use setState
	enable(): void; // maybe use setState
	destructor(): void;
	paint(): void;
	clear(): void;
	focus(): void;
	setState(state: State): void;
	getValue(asArray?: boolean): string[] | string;
	setValue(ids: string[] | string): void;
}

export enum ComboState {
	default,
	error,
	success
}